module.exports = __webpack_public_path__ + "img/logo.4e94935c.png";